<template>
    <form>
        <div class="field">
            <label class="label">Max groups</label>
            <div class="control has-icons-left">
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input  v-model="getSettings.max_groups"
                            v-on:keyup="updateUserSettings"
                            class="input"
                            type="text"
                            placeholder="Max groups">
                    <span class="icon is-small is-left">
                        <i class="fas fa-layer-group"></i>
                    </span>
                </div>
            </div>
        </div>
        <div class="field">
            <label class="label">Group max bids</label>
            <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                <input v-model="getSettings.max_group_bids"
                       v-on:keyup="updateUserSettings"
                       class="input"
                       type="text"
                       placeholder="Group max bids">
                <span class="icon is-small is-left">
                    <i class="fas fa-gavel"></i>
                </span>
            </div>
        </div>
        <div class="field">
            <label class="label">Group max wins</label>
            <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                <input v-model="getSettings.max_group_win"
                       v-on:keyup="updateUserSettings"
                        class="input"
                        type="text"
                        placeholder="Group max wins">
                <span class="icon is-small is-left">
                    <i class="fas fa-trophy"></i>
                </span>
            </div>
        </div>
        <div class="field">
            <label class="label">Price plan</label>
            <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                <div class="select is-fullwidth" :class="{ 'is-loading': isLoading }">
                    <select v-model="userData.price_plan_id" @change="updateUser">
                        <option :value="null">No price plan</option>
                        <option v-for="plan in allPricePlans" :value="plan.id">{{ plan.name }}</option>
                    </select>
                </div>
                <span class="icon is-small is-left">
                    <i class="fas fa-dollar-sign"></i>
                </span>
            </div>
        </div>
    </form>
</template>

<script>
    import apiUsers from '../../../api/apiUsers'
    export default {
        props: ['user'],
        data() {
            return {
                isLoading: false,
                userData: {
                    name: '',
                    email: '',
                    role: '',
                    price_plan_id: null,
                }
            }
        },
        methods: {
            updateUserSettings () {
                setTimeout(() => {
                    this.isLoading = true
                    apiUsers
                        .userSettingsUpdateRequest(this.getSettings)
                        .then((response) => {
                            this.isLoading = false

                        })
                        .catch((error) => {

                        })
                }, 1000)
            },
            updateUser () {
                setTimeout(() => {
                    this.isLoading = true
                    apiUsers
                        .userUpdateRequest(this.user.id, this.userData)
                        .then((response) => {
                            this.isLoading = false

                        })
                        .catch((error) => {

                        })
                }, 1000)
            }
        },
        computed: {
            getSettings: function () {
                return this.$store.getters.getSettings
            },
            allPricePlans () {
                return this.$store.getters.getAllPricePlans
            }
        },
        created () {
            this.$store.dispatch('getAllPricePlansRequest')
            this.userData.price_plan_id = this.user.price_plan_id
            this.userData.name = this.user.name
            this.userData.email = this.user.email
            this.userData.role = this.user.role
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/User/UserSettings.vue